// extracted by mini-css-extract-plugin
module.exports = {"dialogBody":"dialogBody__jwPxs","dialogFooter":"dialogFooter__GIOyW","form":"form__jEASz","tabList":"tabList__Hbtt3","tabPanel":"tabPanel__VAaef"};